import React, { useState, useEffect } from 'react';
import { IconPlus } from '@tabler/icons-react';
import UserForm from './UserForm';
import { useAuth } from "../../../Context/store/context";
import globals from '../../../../globals';
import axios from 'axios';
import '../../MyInvitations/Events.css'
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Adminpermissions from './Adminpermissions';

const CreateUser = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [isPermissionEditOpen, setIsPermissionEditOpen] = useState(false);
  const [roolSectionData, setRoolSectionData] = useState([]);
  const [permissionData, setPermissionData] = useState([]);
  const [actionType, setActionType] = useState(""); 

  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  const toggleDialog = () => setIsDialogOpen(true);
  const toggleEditDialog = (adminId = null) => {
    
    setIsDialogEditOpen(true);
    
  };
  const togglePermissionEditDialog = (adminId = null, type) => {
  const matchedRool = roolSectionData.find((rool) => rool.adminId === adminId);
  console.log("Action Type:", type); // Log type (permissions/edit)
  setIsPermissionEditOpen(true);
  setPermissionData(matchedRool);
  setActionType(type);
};
  const closeDialog = () =>{ 
    setIsDialogOpen(false);
    fetchadmin()
  }
  const closepermissionDialog = () => {
    setIsPermissionEditOpen(false);
    fetchadmin()
  }
  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.admin.title, globals.admin.icon);
  }, []);

  const fetchadmin = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getadmindata`);
      console.log(response.data.admindata);
      setRoolSectionData(response.data.admindata)
    } catch (error) {
      console.error('Error fetching rools:', error);
    }
  };
  const handleDeleteData = async (adminId) => {
    try {
      console.log("adminId",adminId)
      const matchedRool = roolSectionData.find((rool) => rool.adminId === adminId);
      console.log("matchedRool", matchedRool.adminId);
      const response = await axios.delete(`http://localhost:4000/getadmindelete/${matchedRool.adminId}`);
      console.log(response.data.message);
      fetchadmin();
    } catch (error) {
      console.error('Error deleting role:', error);
    }
  };
  useEffect(() => {

    fetchadmin();
  }, []);
  return (
    <div style={{ padding: "2%" }}>
      <div>
      <div className="container-xxl container-p-y bs-stepper wizard-vertical wizard-numbered vertical mt-2 content-header mb-3 d-flex justify-content-between">
        <div className="sec-titler">
          <h2 className="text-primary">Create Admin Page</h2>
          <div className="title-shape"></div>
          <small className="fs-11 mb-0"></small>
        </div>
        <div className="mb-0 text-right">
          <button className="btn btn-primary align-middle" onClick={toggleDialog}>
            <IconPlus className="me-sm-1 me-0" size={20} />
            Create Admin
          </button>
        </div>

      </div>
      
      </div>
    <div className="mt-4">
      <div  className="card mb-3 p-3">
            
              <div>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sl.no</th>
                      <th>First name</th>
                      <th>Last name</th>
                      <th>Email</th>
                      <th>Mobile Number</th>
                      <th>Registed Date</th>
              
                      <th>permissions </th>
                      <th>Delete </th>
                    </tr>
                  </thead>
                  <tbody>
                  {Array.isArray(roolSectionData) && roolSectionData.map((item, index) => (
  <tr key={item.adminId}>
    <td>{index + 1}</td>
  <td>{item.firstName}</td>
  <td>{item.lastName}</td>
  <td>{item.email}</td>
  <td>{item.contactNo}</td>
  <td>{new Date(item.createdAt).toISOString().split('T')[0]}</td>


  
  <td> <button className="btn btn-primary flex items-center" 
onClick={() => togglePermissionEditDialog(item.adminId,"permissions")}
>
  permissions
</button></td>

  <td>  <button className="btn btn-primary align-middle flex items-center"
 onClick={() => handleDeleteData(item.adminId)}
>
  <DeleteIcon className="me-sm-1 me-0" fontSize="small"
   />
  Delete
</button></td>
</tr>
                  ))}
                  
                    
                  </tbody>
                </table>
              </div>
            </div>
      </div>
      {isDialogOpen && (
        <UserForm onClose={closeDialog} />
      )}
      {isPermissionEditOpen && (
        <Adminpermissions actionType={actionType}  Data={permissionData} onClose={closepermissionDialog} />
      )}
    </div>
  );
};

export default CreateUser;
